import { render, staticRenderFns } from "./ViewPaymentModules.vue?vue&type=template&id=4f671f6d&scoped=true"
import script from "./ViewPaymentModules.vue?vue&type=script&lang=js"
export * from "./ViewPaymentModules.vue?vue&type=script&lang=js"
import style0 from "./ViewPaymentModules.vue?vue&type=style&index=0&id=4f671f6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f671f6d",
  null
  
)

export default component.exports